import { Cell, Column, Heading, None } from "@edgetier/client-components";
import { FunctionComponent, memo } from "react";
import { IInteraction } from "@edgetier/watchtower-types";
import { IProps } from "./interactions-table-agent-column.types";
import "./interactions-table-agent-column.scss";

/**
 * Display the agent handling an interaction.
 * @returns Table column.
 */
const InteractionsTableAgentColumn: FunctionComponent<IProps> = () => {
    return (
        <Column>
            <Heading>Agent</Heading>
            <Cell<IInteraction>>{({ agent }) => agent?.name ?? <None />}</Cell>
        </Column>
    );
};

export default memo(InteractionsTableAgentColumn);
